import React from 'react';

export const LogoWhite = (props) => (
  <svg
    fill="none"
    height="49"
    viewBox="0 0 48 49"
    width="48"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <rect
      fill="#2F1359"
      height="32.5222"
      transform="rotate(1.03788 9.22314 7.70923)"
      width="29.3487"
      x="9.22314"
      y="7.70923"
    />
    <path
      clipRule="evenodd"
      d="M33.6204 3.68821L13.8921 3.5943C8.40243 3.56832 3.91354 8.00672 3.88608 13.49L3.77905 34.7592C3.75122 40.2424 8.19519 44.7233 13.6849 44.7492L33.4136 44.8432C38.9017 44.8694 43.3918 40.4308 43.4196 34.9475L43.5266 13.6783C43.5541 8.19505 39.1087 3.71404 33.6204 3.68821ZM37.5631 34.9199C37.5515 37.177 35.7019 39.006 33.4428 38.9953L25.6304 38.9582L25.6863 27.8706L21.5871 27.8515L21.5312 38.9387L13.7159 38.9015C11.4554 38.8906 9.62708 37.0455 9.63846 34.7872L9.74555 13.5177C9.75679 11.2604 11.6037 9.43149 13.8639 9.44237L21.5535 9.47902L21.4965 20.8128L25.5946 20.8325L25.6516 9.49838L33.5912 9.53619C35.8499 9.54688 37.6811 11.3919 37.6698 13.6506L37.5631 34.9199Z"
      fill="white"
      fillRule="evenodd"
    />
  </svg>
);
